import { render } from "./usesChart.vue?vue&type=template&id=0dec25e4"
import script from "./usesChart.vue?vue&type=script&lang=js"
export * from "./usesChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__